export default {
  SHOW_DETAILED_CHART_VIEW: 'SHOW_DETAILED_CHART_VIEW',
  CHANGE_CHART_DATAZOOM: 'CHANGE_CHART_DATAZOOM'
};
